export default __webpack_public_path__ + "static/webhooks-automatic-retry-2e05808743a4662efc2d508992e93f33.png";